import CloseIcon from '@mui/icons-material/Close'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Dialog, DialogContent, IconButton } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AddToLightboxDialog } from '../../../main-components/content/account-details/sections/buyer/lightbox/AddToLightboxDialog'
import styles from './ImageZoomInModal.module.scss'
import Notiflix from 'notiflix'
import { BASE_URL } from '../../../../utils/constants'
import instance from '../../../../providers/axios.config'
import { IImage } from '../../../../utils/types';

interface IProps {
  image?: string
  open: boolean
  handleOpen: () => void
  title?: string
  showOptionsUser?: boolean
  imageDetails: IImage;
}

export const ImageZoomInModal = (props: IProps) => {
  const { imageDetails, image, open, handleOpen, title, showOptionsUser } = props

  const { t } = useTranslation()

  const [openAddToLightbox, setOpenAddToLightbox] = useState(false)

  const handleOpenAddToLightbox = () => {
    setOpenAddToLightbox(!openAddToLightbox)
  }

  
  const handleDownload = async () => {
    if (!image) return false;
    
    Notiflix.Loading.standard({ svgColor: '#c11b1e' });
    
    try {
      const response = await fetch(image);
      const blob = await response.blob();
      
      // Force download by changing MIME type
      const forceDownloadBlob = new Blob([blob], { 
        type: 'application/force-download' 
      });
      
      const url = URL.createObjectURL(forceDownloadBlob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Layerstock-ID_${imageDetails.id} - ${title}.${imageDetails.extension}`;
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      
      URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Download failed:', error);
      window.open(image, '_blank');
    } finally {
      Notiflix.Loading.remove();
    }
};

  const handleConfirmAddToLightbox = () => {
    handleOpenAddToLightbox()
  }

  return (
    <>
      {/* <AddToLightboxDialog
        open={openAddToLightbox}
        dialogTitle={t('Lightbox')}
        handleOpen={handleOpenAddToLightbox}
        handleConfirm={handleConfirmAddToLightbox}
      /> */}
      <Dialog
        open={open}
        onClose={handleOpen}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '90vw',
            maxHeight: '90vh',
            width: 'auto',
            height: 'auto',
            background: 'transparent',
            boxShadow: 'none'
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(43,49,57,0.8)', // Try to remove this to see the result
          }
        }}
      >
        <DialogContent>
          <div className={styles.container}>
            <div className={styles.buttons}>
              {showOptionsUser && <IconButton
                sx={{
                  color: 'white',
                  backgroundColor: '#50505090',
                  '&:hover': {
                    backgroundColor: '#c11b1e90',
                  },
                }}
                onClick={() => handleDownload()}
              >
                <VisibilityIcon sx={{ height: 30, width: 30 }} />
              </IconButton>}
              <IconButton
                onClick={handleOpen}
                sx={{
                  color: 'white',
                  backgroundColor: '#50505090',
                  '&:hover': {
                    backgroundColor: '#c11b1e90',
                  },
                }}
              >
                <CloseIcon sx={{ height: 30, width: 30 }} />
              </IconButton>
            </div>

            <div>
              <img src={image} alt='zoom' className={styles.image} />
            </div>

            {/* <div className={styles.titleContainer}>
              <div className={styles.titleContent}>{title}</div>
            </div> */}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
